module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sideArea d-flex flex-column pt-5 bg-lightest position-relative"
  }, [_c('div', {
    staticClass: "blueArea bg-color-1 w-100 "
  }), _vm._v(" "), _c('div', {
    staticClass: "findTicket text-center bg-lightest p-3 border-medium radius-normal mx-3"
  }, [_c('span', [_vm._v("Insert ticket number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ticketNr),
      expression: "ticketNr"
    }],
    staticClass: "ticketNr w-100 border-0 text-center dark mt-0",
    attrs: {
      "type": "text",
      "placeholder": "0000",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.ticketNr)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.viewReservation($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ticketNr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "searchTicket pointer bg-color-6 radius-normal border-0 lightest font-weight-600 w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.viewReservation()
      }
    }
  }, [_vm._v("Find a ticket")])]), _vm._v(" "), _c('div', {
    staticClass: "newBooking p-3 my-2 w-100"
  }, [_c('button', {
    staticClass: "newBookingBtn pointer bg-dark radius-normal border-0 lightest w-100 fs-large",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newReservation
    }
  }, [_vm._v("New Booking")])]), _vm._v(" "), _c('div', {
    staticClass: "informationArea p-3 w-100 bg-lighter border-top-light border-bottom-light scroll-y-auto"
  }, [(_vm.nrVisibleAlerts < 1) ? _c('div', {
    staticClass: "text-center dark bold fs-large w-50 m-auto mt-5 pt-5"
  }, [_vm._v("\n        You have no notes or alerts.\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.notifications), function(notification) {
    return (!notification.markedAsRead) ? _c('div', {
      staticClass: "infoCard fs-small pb-2 mt-2"
    }, [_c('notification', {
      staticClass: "border-bottom-medium",
      attrs: {
        "notification": notification
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'notifications'
      }
    }
  }, [(false) ? _c('div', {
    staticClass: "bold text-center font-weight-600 py-2 moreAlerts brand"
  }, [_vm._v("\n        " + _vm._s(_vm.nrVisibleAlerts) + " more alerts\n      ")]) : _c('div', {
    staticClass: "dark text-center py-2"
  }, [_vm._v("\n        view all\n      ")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-57b07989", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57b07989"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/SidePanel.vue
// module id = 1534
// module chunks = 0